module.exports = __webpack_public_path__ + "img/uvod.ed4f1211.png";